module.exports = __webpack_public_path__ + "img/timer.c9f69efe.svg";